/* Shopify tears the privacy banner out of the DOM on dismiss, so there is nothing left for CSS
   to animate. Catch the removal, put the original node back for one beat, fade it, then drop it.
   The original is reused rather than cloned: the prefs buttons are styled by ID and have no
   matching classes, so a clone would lose its colours halfway through the fade. */
(() => {
  const TARGETS = new Set(['shopify-pc__banner', 'shopify-pc__prefs', 'shopify-pc__prefs__overlay']);
  const DURATION = 320;

  const fadeOut = (node) => {
    node.dataset.mcbGhost = '';
    node.setAttribute('aria-hidden', 'true');
    node.style.pointerEvents = 'none';
    document.body.appendChild(node);
    setTimeout(() => node.remove(), DURATION);
  };

  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.removedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        // dropping our own ghost fires this observer again, so skip anything already fading
        if ('mcbGhost' in node.dataset) continue;
        if (TARGETS.has(node.id)) fadeOut(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
